import ArchiveSeasonStandingsDb from "./ArchiveSeasonStandingsDb.jsx";

export default function ArchiveSeasonStandingsTeamDb() {
    return (
        <ArchiveSeasonStandingsDb
            scopeType="TEAM"
            classKey=""
            title="Archiv Standings Team"
            pillLabel="TEAM"
        />
    );
}
